'use strict';//Indicating browser should run only in java script mode
; (function () {
    //angular.module('EMR.GoldenThreadViewModule',[]);

    var selectInterventionPopupViewModuleRoutes = [

        {

            "name": "GoldenThreadSelectInterventionPopup",
            "templateUrl": "<div emr-select-intervention-popup></div>",
            "RoutingNumber": 1041,
            files: [
                "AngularScripts/SelectInterventionPopupView/Services/SelectInterventionPopupService.js",
                "AngularScripts/SelectInterventionPopupView/Controllers/SelectInterventionPopupController.js",

            ]
        },


    ];

    angular.module('EMR.SelectInterventionPopupViewModule', [])
        .constant("selectInterventionPopupViewModuleRoutes", selectInterventionPopupViewModuleRoutes)
        .config(["$stateProvider", "EmrRouteProvider", "selectInterventionPopupViewModuleRoutes",
            function ($stateProvider, EmrRouteProvider, selectInterventionPopupViewModuleRoutes) {
                EmrRouteProvider.registerStates(selectInterventionPopupViewModuleRoutes, $stateProvider);
            }]);
})();